import React, { useState } from 'react';
import { SplitSquareHorizontalIcon, Loader2Icon, SparklesIcon, TrophyIcon } from 'lucide-react';
export function ABTestVariants() {
  const [isGenerating, setIsGenerating] = useState(false);
  const [hasGenerated, setHasGenerated] = useState(false);
  const handleGenerate = () => {
    setIsGenerating(true);
    setTimeout(() => {
      setIsGenerating(false);
      setHasGenerated(true);
    }, 2000);
  };
  return <div className="max-w-5xl mx-auto space-y-8 animate-in fade-in duration-500" data-id="element-8">
      <div data-id="element-9">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-10">
          Variantes para A/B Test
        </h1>
        <p className="text-slate-500 mt-1" data-id="element-11">
          Genera variaciones científicamente diseñadas para probar qué convierte
          mejor.
        </p>
      </div>

      <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200" data-id="element-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-13">
          <div className="space-y-2" data-id="element-14">
            <label className="block text-sm font-medium text-slate-700" data-id="element-15">
              Elemento a Testear
            </label>
            <select className="w-full p-2.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white" data-id="element-16">
              <option data-id="element-17">Headline (Titular de Landing)</option>
              <option data-id="element-18">Ad Hook (Gancho de Anuncio)</option>
              <option data-id="element-19">Call to Action (Botón)</option>
              <option data-id="element-20">Asunto de Email</option>
            </select>
          </div>
          <div className="space-y-2" data-id="element-21">
            <label className="block text-sm font-medium text-slate-700" data-id="element-22">
              Texto Original Base
            </label>
            <input type="text" placeholder="Ej: Aprende a costear tus postres" className="w-full p-2.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" defaultValue="Aprende a costear tus postres" data-id="element-23" />
          </div>
        </div>
        <div className="flex justify-end pt-6 border-t border-slate-100" data-id="element-24">
          <button onClick={handleGenerate} disabled={isGenerating} className="bg-indigo-600 hover:bg-indigo-700 text-white px-8 py-2.5 rounded-lg font-medium flex items-center gap-2 disabled:opacity-50 transition-colors" data-id="element-25">
            {isGenerating ? <>
                <Loader2Icon className="w-5 h-5 animate-spin" data-id="element-26" /> Creando
                Variantes...
              </> : <>
                <SparklesIcon className="w-5 h-5" data-id="element-27" /> Generar 4 Variantes
              </>}
          </button>
        </div>
      </div>

      {hasGenerated && <div className="space-y-6 animate-in slide-in-from-bottom-4 duration-500" data-id="element-28">
          <h2 className="text-xl font-bold text-slate-900" data-id="element-29">
            Variantes de Headline Sugeridas
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-30">
            <div className="bg-white p-6 rounded-xl shadow-sm border-2 border-slate-200 hover:border-indigo-300 transition-colors relative" data-id="element-31">
              <div className="absolute top-4 right-4 text-slate-300" data-id="element-32">
                Control
              </div>
              <span className="text-xs font-bold text-slate-500 uppercase tracking-wider" data-id="element-33">
                Variante A (Original Mejorado)
              </span>
              <h3 className="text-xl font-bold text-slate-900 mt-2 mb-4" data-id="element-34">
                Aprende a costear tus postres y asegura tu ganancia.
              </h3>
              <div className="bg-slate-50 p-3 rounded text-sm text-slate-600" data-id="element-35">
                <strong data-id="element-36">Hipótesis:</strong> Claridad directa. Funciona bien para
                tráfico tibio que ya sabe que tiene un problema de costeo.
              </div>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-sm border-2 border-indigo-500 relative" data-id="element-37">
              <div className="absolute top-0 right-0 bg-indigo-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg rounded-tr-xl flex items-center gap-1" data-id="element-38">
                <TrophyIcon className="w-3 h-3" data-id="element-39" /> Mayor Potencial
              </div>
              <span className="text-xs font-bold text-indigo-600 uppercase tracking-wider" data-id="element-40">
                Variante B (Ángulo de Dolor)
              </span>
              <h3 className="text-xl font-bold text-slate-900 mt-2 mb-4" data-id="element-41">
                Deja de regalar tu trabajo: La fórmula exacta para costear
                postres sin perder dinero.
              </h3>
              <div className="bg-indigo-50 p-3 rounded text-sm text-indigo-800 border border-indigo-100" data-id="element-42">
                <strong data-id="element-43">Hipótesis:</strong> Ataca el dolor principal ("regalar
                trabajo") y ofrece una solución específica ("fórmula exacta").
              </div>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-sm border-2 border-slate-200 hover:border-indigo-300 transition-colors" data-id="element-44">
              <span className="text-xs font-bold text-slate-500 uppercase tracking-wider" data-id="element-45">
                Variante C (Ángulo de Beneficio/Deseo)
              </span>
              <h3 className="text-xl font-bold text-slate-900 mt-2 mb-4" data-id="element-46">
                Cómo lograr un 60% de margen en cada postre que vendes desde
                casa.
              </h3>
              <div className="bg-slate-50 p-3 rounded text-sm text-slate-600" data-id="element-47">
                <strong data-id="element-48">Hipótesis:</strong> Usa números específicos (60%) para
                generar curiosidad y credibilidad.
              </div>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-sm border-2 border-slate-200 hover:border-indigo-300 transition-colors" data-id="element-49">
              <span className="text-xs font-bold text-slate-500 uppercase tracking-wider" data-id="element-50">
                Variante D (Ángulo de Curiosidad)
              </span>
              <h3 className="text-xl font-bold text-slate-900 mt-2 mb-4" data-id="element-51">
                El error matemático que cometen el 90% de las reposteras caseras
                al cobrar.
              </h3>
              <div className="bg-slate-50 p-3 rounded text-sm text-slate-600" data-id="element-52">
                <strong data-id="element-53">Hipótesis:</strong> Genera FOMO (Fear of Missing Out).
                El usuario hace clic para saber si está cometiendo ese error.
              </div>
            </div>
          </div>
        </div>}
    </div>;
}